// extracted by mini-css-extract-plugin
export default {"container":"States_container__DRvjU","Main":"States_Main__EAjbt","Legend":"States_Legend__IQJQg"};